<ng-content select=".btn--editor-controls"></ng-content>

<div class="column-image">
  <img *ngIf="column['image']" [src]="column['image']['url']" [alt]="column['image']['altText']">
</div>
